import React from "react";
import { ThemeProvider } from "styled-components";
import { Routes, Route } from "react-router-dom";
import theme from "./theme";
import GlobalStyle from "./GlobalStyle";
import { LanguageProvider } from "./i18n/LanguageContext";
import { FavoritesProvider } from "./context/FavoritesContext";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home.jsx";
import How from "./pages/How";
import VendorProfile from "./pages/VendorProfile";
import Saved from "./pages/Saved";
import ListBusiness from "./pages/ListBusiness";
import Manage from "./pages/Manage";
import Admin from "./pages/Admin";
import About from "./pages/About";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <LanguageProvider>
        <AuthProvider>
          <FavoritesProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/how" element={<How />} />
              <Route path="/vendor/:id" element={<VendorProfile />} />
              <Route path="/saved" element={<Saved />} />
              <Route path="/list" element={<ListBusiness />} />
              <Route path="/manage" element={<Manage />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </FavoritesProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}
